export default "__VITE_ASSET__JBTrxsUK__"